var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E44D26",
    d: "M19.037 113.876L9.032 1.661h109.936l-10.016 112.198l-45.019 12.48z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F16529",
    d: "m64 116.8l36.378-10.086l8.559-95.878H64z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M64 52.455H45.788L44.53 38.361H64V24.599H29.489l.33 3.692l3.382 37.927H64zm0 35.743l-.061.017l-15.327-4.14l-.979-10.975H33.816l1.928 21.609l28.193 7.826l.063-.017z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M63.952 52.455v13.763h16.947l-1.597 17.849l-15.35 4.143v14.319l28.215-7.82l.207-2.325l3.234-36.233l.335-3.696h-3.708zm0-27.856v13.762h33.244l.276-3.092l.628-6.978l.329-3.692z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml5);
export default __webpack_public_path__ + "static/media/html5.248340455fcbd9a264863abc898b9168.svg";
export { ForwardRef as ReactComponent };